var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeopen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.752 11.2998C13.1194 2.47831 4.67101 9.0334 2.28022 11.2537C1.89328 11.6131 1.87485 12.2165 2.23416 12.5989C10.8299 21.623 19.3244 14.9113 21.7198 12.6495C22.1067 12.2856 22.1251 11.6775 21.752 11.2998ZM12 14.7685C10.4706 14.7685 9.23147 13.5294 9.23147 12C9.23147 10.4706 10.4706 9.23148 12 9.23148C13.5294 9.23148 14.7685 10.4706 14.7685 12C14.7685 13.5294 13.5294 14.7685 12 14.7685Z",
    fill: "#235789"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen);
export default __webpack_public_path__ + "static/media/Eyeopen.c46b7837.svg";
export { ForwardRef as ReactComponent };